import { styled } from '@mui/material';

export const ServiceTitle = styled('span')(() => ({
  marginBottom: 27,
  fontSize: 16,
  fontWeight: 600,
}));
